import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Bot, User as UserIcon, Loader2 } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminSessionDetail = () => {
  const { sessionId } = useParams();
  const { authHeaders } = useAuth();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/admin/sessions/${sessionId}`, {
          withCredentials: true,
          headers: authHeaders(),
        });
        setMessages(res.data);
      } catch {
        toast.error('Σφάλμα φόρτωσης συνομιλίας');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [sessionId, authHeaders]);

  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <header className="bg-slate-800 border-b border-slate-700 px-6 py-4 flex items-center justify-between sticky top-0 z-10">
        <Link
          to="/admin"
          data-testid="session-back-btn"
          className="flex items-center space-x-2 text-slate-300 hover:text-white"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Πίσω στον πίνακα</span>
        </Link>
        <span className="text-xs font-mono text-slate-500 hidden md:inline">{sessionId}</span>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-6" data-testid="admin-session-detail">
        <h2 className="text-xl font-bold mb-6">Πλήρης Συνομιλία ({messages.length} μηνύματα)</h2>

        {loading ? (
          <div className="text-center py-16">
            <Loader2 className="w-8 h-8 animate-spin mx-auto text-orange-500" />
          </div>
        ) : messages.length === 0 ? (
          <div className="text-center py-16 text-slate-500">Δεν βρέθηκαν μηνύματα</div>
        ) : (
          <div className="space-y-4">
            {messages.map((m, i) => (
              <div
                key={m.id || i}
                data-testid={`session-msg-${i}`}
                className={`flex items-start space-x-3 ${
                  m.role === 'user' ? 'flex-row-reverse space-x-reverse' : ''
                }`}
              >
                <div
                  className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${
                    m.role === 'user' ? 'bg-slate-700' : 'bg-orange-500'
                  }`}
                >
                  {m.role === 'user' ? <UserIcon className="w-4 h-4" /> : <Bot className="w-4 h-4" />}
                </div>
                <div className={`flex-1 ${m.role === 'user' ? 'text-right' : ''}`}>
                  <div
                    className={`inline-block px-5 py-3 rounded-lg max-w-[85%] ${
                      m.role === 'user'
                        ? 'bg-slate-700 text-white'
                        : 'bg-slate-800 border border-slate-700 text-slate-200'
                    }`}
                  >
                    <p className="whitespace-pre-wrap text-sm">{m.content}</p>
                  </div>
                  <div className="text-xs text-slate-600 mt-1">
                    {new Date(m.timestamp).toLocaleString('el-GR')}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminSessionDetail;
